"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * Used to update {@link WindowItem windowItem} attributes
 *
 * @author JMt
 */


var WindowItemUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemUpdateDTO, _DomainObject_1$Domai);

  /**
   * Creates new DTO for {@link WindowItem windowItem} update
   *
   */
  function WindowItemUpdateDTO(id, promoPrice, regularPrice, cmForecast, // TODO ZSt number ???
  systemVolume, promoVolume, requestSecondaryPlacement, secondaryPlacement, posAttributes, memberCredits, logisticComment, returnable, returnableCondition, endDateOfReturn, distrModelId, distributionModelDays, lockType, selloutSales, ignoreForTraining, activeSale, extraSaleSticker, tastings, tvCommercial, onPicture, groupOfSitesId, warningFlags, // TODO ZSt warning flag update
  substituteProductId, marketingComment, directDelivery, directDeliverySites, measureUnits, simulation, // TODO ZSt check this
  lastSystemVolumeUpdate, regularVolume, justInTime, lastPromoVolumeUpdate, lastSystemVolumeComputationFailure, forecastCoordinatorFlag) {
    var _this;

    _classCallCheck(this, WindowItemUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemUpdateDTO).call(this));
    _this.id = id;
    _this.promoPrice = promoPrice;
    _this.regularPrice = regularPrice;
    _this.cmForecast = cmForecast;
    _this.systemVolume = systemVolume;
    _this.promoVolume = promoVolume;
    _this.requestSecondaryPlacement = requestSecondaryPlacement;
    _this.secondaryPlacement = secondaryPlacement;
    _this.posAttributes = posAttributes;
    _this.memberCredits = memberCredits;
    _this.logisticComment = logisticComment;
    _this.returnable = returnable;
    _this.returnableCondition = returnableCondition;
    _this.endDateOfReturn = endDateOfReturn;
    _this.distrModelId = distrModelId;
    _this.distributionModelDays = distributionModelDays;
    _this.lockType = lockType;
    _this.selloutSales = selloutSales;
    _this.ignoreForTraining = ignoreForTraining;
    _this.activeSale = activeSale;
    _this.extraSaleSticker = extraSaleSticker;
    _this.tastings = tastings;
    _this.tvCommercial = tvCommercial;
    _this.onPicture = onPicture;
    _this.groupOfSitesId = groupOfSitesId;
    _this.warningFlags = warningFlags;
    _this.substituteProductId = substituteProductId;
    _this.marketingComment = marketingComment;
    _this.directDelivery = directDelivery;
    _this.directDeliverySites = directDeliverySites;
    _this.measureUnits = measureUnits;
    _this.simulation = simulation;
    _this.lastSystemVolumeUpdate = lastSystemVolumeUpdate;
    _this.regularVolume = regularVolume;
    _this.justInTime = justInTime;
    _this.lastPromoVolumeUpdate = lastPromoVolumeUpdate;
    _this.lastSystemVolumeComputationFailure = lastSystemVolumeComputationFailure;
    _this.forecastCoordinatorFlag = forecastCoordinatorFlag;
    return _this;
  }

  _createClass(WindowItemUpdateDTO, null, [{
    key: "fromRegularPrice",
    value: function fromRegularPrice(id, regularPrice) {
      return new WindowItemUpdateDTO(id).copy('regularPrice', regularPrice);
    }
  }, {
    key: "fromPOSAttributes",
    value: function fromPOSAttributes(id, attributes) {
      return new WindowItemUpdateDTO(id).copy('posAttributes', attributes);
    }
    /** returns true when dto does not contain any change */

  }, {
    key: "isEmpty",
    value: function isEmpty(dto) {
      return utils_1.Utils.isUndefined(dto.promoPrice) && utils_1.Utils.isUndefined(dto.regularPrice) && utils_1.Utils.isUndefined(dto.cmForecast) && utils_1.Utils.isUndefined(dto.systemVolume) && utils_1.Utils.isUndefined(dto.promoVolume) && utils_1.Utils.isUndefined(dto.requestSecondaryPlacement) && utils_1.Utils.isUndefined(dto.secondaryPlacement) && utils_1.Utils.isUndefined(dto.posAttributes) && utils_1.Utils.isUndefined(dto.memberCredits) && utils_1.Utils.isUndefined(dto.logisticComment) && utils_1.Utils.isUndefined(dto.returnable) && utils_1.Utils.isUndefined(dto.returnableCondition) && utils_1.Utils.isUndefined(dto.endDateOfReturn) && utils_1.Utils.isUndefined(dto.distrModelId) && utils_1.Utils.isUndefined(dto.distributionModelDays) && utils_1.Utils.isUndefined(dto.lockType) && utils_1.Utils.isUndefined(dto.selloutSales) && utils_1.Utils.isUndefined(dto.ignoreForTraining) && utils_1.Utils.isUndefined(dto.activeSale) && utils_1.Utils.isUndefined(dto.extraSaleSticker) && utils_1.Utils.isUndefined(dto.tastings) && utils_1.Utils.isUndefined(dto.tvCommercial) && utils_1.Utils.isUndefined(dto.onPicture) && utils_1.Utils.isUndefined(dto.groupOfSitesId) && utils_1.Utils.isUndefined(dto.warningFlags) && utils_1.Utils.isUndefined(dto.substituteProductId) && utils_1.Utils.isUndefined(dto.marketingComment) && utils_1.Utils.isUndefined(dto.directDelivery) && utils_1.Utils.isUndefined(dto.directDeliverySites) && utils_1.Utils.isUndefined(dto.measureUnits) && utils_1.Utils.isUndefined(dto.simulation) && utils_1.Utils.isUndefined(dto.lastSystemVolumeUpdate) && utils_1.Utils.isUndefined(dto.regularVolume) && utils_1.Utils.isUndefined(dto.justInTime) && utils_1.Utils.isUndefined(dto.lastPromoVolumeUpdate) && utils_1.Utils.isUndefined(dto.lastSystemVolumeComputationFailure) && utils_1.Utils.isUndefined(dto.forecastCoordinatorFlag);
    }
  }]);

  return WindowItemUpdateDTO;
}(DomainObject_1.DomainObject);

exports.WindowItemUpdateDTO = WindowItemUpdateDTO;